module.exports = __webpack_public_path__ + "static/media/IMG_9725 (1) - Copy.12ef636a.JPG";